<template>
  <v-dialog v-model="dialog" max-width="600" @input="$emit('input', $event)">
    <v-card style="background-color:#DEB887">
      <v-card-title class="headline">
        <v-icon left>mdi-keyboard</v-icon>
        Keyboard Shortcuts
      </v-card-title>
      <v-card-text>
        <v-container>
          <!-- Main Tab Navigation -->
          <div class="mb-4">
            <h3 class="text-h6 mb-2">Main Tab Navigation</h3>
            <v-list dense>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title><kbd>Alt</kbd> + <kbd>1</kbd></v-list-item-title>
                  <v-list-item-subtitle>Go to Character Sheet</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title><kbd>Alt</kbd> + <kbd>2</kbd></v-list-item-title>
                  <v-list-item-subtitle>Go to Maneuver Tracker</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title><kbd>Alt</kbd> + <kbd>3</kbd></v-list-item-title>
                  <v-list-item-subtitle>Go to Spell Tracker</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>

          <!-- Panel Toggles -->
          <div class="mb-4">
            <h3 class="text-h6 mb-2">Panel Toggles</h3>
            <v-list dense>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title><kbd>Ctrl</kbd> + <kbd>1</kbd></v-list-item-title>
                  <v-list-item-subtitle>Toggle Quick Details</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title><kbd>Ctrl</kbd> + <kbd>2</kbd></v-list-item-title>
                  <v-list-item-subtitle>Toggle Point Tracker</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title><kbd>Ctrl</kbd> + <kbd>3</kbd></v-list-item-title>
                  <v-list-item-subtitle>Toggle Notes</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title><kbd>Ctrl</kbd> + <kbd>4</kbd></v-list-item-title>
                  <v-list-item-subtitle>Toggle Buffs</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>

          <!-- Character Sheet Navigation -->
          <div class="mb-4">
            <h3 class="text-h6 mb-2">Character Sheet Tab Navigation</h3>
            <v-list dense>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title><kbd>Tab</kbd> + <kbd>→</kbd></v-list-item-title>
                  <v-list-item-subtitle>Next character sheet tab (Ability Scores → Defense → Offense → Skills → Feats → Equipment → Notes)</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title><kbd>Tab</kbd> + <kbd>←</kbd></v-list-item-title>
                  <v-list-item-subtitle>Previous character sheet tab</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>

          <!-- Spell Tracker Navigation -->
          <div class="mb-4">
            <h3 class="text-h6 mb-2">Spell Tracker Navigation</h3>
            <v-list dense>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title><kbd>Tab</kbd> + <kbd>→</kbd></v-list-item-title>
                  <v-list-item-subtitle>Next spell section</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title><kbd>Tab</kbd> + <kbd>←</kbd></v-list-item-title>
                  <v-list-item-subtitle>Previous spell section</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="closeDialog">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'HotkeysDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('input', false);
    }
  }
}
</script>

<style scoped>
/* Keyboard key styling for hotkeys dialog */
kbd {
  background-color: #f7f7f7;
  border: 1px solid #ccc;
  border-radius: 3px;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.2), 0 0 0 2px #fff inset;
  color: #333;
  display: inline-block;
  font-family: monospace;
  font-size: 11px;
  font-weight: bold;
  line-height: 1;
  padding: 2px 4px;
  white-space: nowrap;
  margin: 0 2px;
}
</style>
